// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YB3P","newExpiryDate":"styles_newExpiryDate__cM4OI","footer":"styles_footer__3a6hl"};